<template>
  <div class="mt-2">
    <WarningDisable permission="explore" />
    <div class="flex gap-6">
      <div class="w-3xs space-y-4">
        <CreateScanAction />
        <Filter />
        <ScanHistory />
      </div>
      <div class="flex grow flex-col overflow-x-auto">
        <div class="flex items-baseline justify-between">
          <FolderBreadcrumbs />
          <div
            v-if="
              explorer_store.action?.status &&
              explorer_store.action?.status.toLowerCase() === 'complete'
            "
            class="dropdown dropdown-end"
          >
            <div tabindex="0" role="button" class="btn m-1">
              <i class="fa-solid fa-ellipsis"></i>
            </div>
            <ul
              tabindex="-1"
              class="dropdown-content menu bg-base-100 rounded-box z-1 w-52 p-2 shadow-sm"
            >
              <li>
                <label for="file-upload">
                  <i class="fa-solid fa-upload text-base-content/80"></i>
                  <span>Đẩy xuống máy trạm</span>
                </label>
                <input
                  id="file-upload"
                  type="file"
                  class="file-input hidden"
                  @change="handle_file_upload"
                />
              </li>
              <li>
                <button
                  @click="
                    createAction({
                      agent_id: client_detail.id,
                      action: 'scan',
                      type: 'explore',
                      path: str_from_query('path'),
                    }).then((action_id: string | undefined) => {
                      if (!action_id) {
                        toast.error('Không tìm thấy định danh');
                        return;
                      }
                      toast.success('Tạo lệnh quét thành công');
                      explorer_store.get_files();
                    })
                  "
                >
                  <i class="fa-solid fa-rotate-right text-base-content/80"></i>
                  <span>Quét lại</span>
                </button>
              </li>
            </ul>
          </div>
          <ActionStatus
            v-if="
              explorer_store.action?.status &&
              explorer_store.action?.status.toLowerCase() !== 'complete'
            "
            :status="explorer_store.action?.status"
          />
        </div>
        <div class="grow overflow-x-auto">
          <div
            v-if="view_state === 'loading'"
            class="flex items-center justify-center p-8"
          >
            <Loading />
          </div>
          <template v-else-if="view_state === 'showingFiles'">
            <div class="bg-base-100 mb-2 overflow-x-auto">
              <FilesTable />
            </div>
            <Pagination :total_pages="explorer_store.total_pages" />
          </template>
          <div
            v-else-if="view_state === 'showingDisks'"
            class="bg-base-100 mb-2 overflow-x-auto"
          >
            <DisksTable />
          </div>
          <ActionStatus
            v-else-if="view_state === 'showingActionStatus'"
            :status="explorer_store.action?.status"
          />
          <div
            v-else-if="view_state === 'notFound'"
            class="flex items-center justify-center p-8"
          >
            <NotFound />
          </div>
        </div>
      </div>
    </div>
  </div>
  <ConfirmUploadModal :file="explorer_store.upload_file" />
</template>

<script setup lang="ts">
import { str_from_query } from "@/api";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import Pagination from "@/components/PaginationTemplate.vue";
import { computed, onMounted, type ComputedRef } from "vue";
import { toast } from "vue3-toastify";
import { use_client_detail } from "../useClientDetail";
import WarningDisable from "../WarningDisable.vue";
import ActionStatus from "./ActionStatus.vue";
import ConfirmUploadModal from "./ConfirmUploadModal.vue";
import CreateScanAction from "./CreateScanAction.vue";
import DisksTable from "./DisksTable.vue";
import Filter from "./ExplorerFilter.vue";
import FilesTable from "./FilesTable.vue";
import FolderBreadcrumbs from "./FolderBreadcrumbs.vue";
import ScanHistory from "./ScanHistory.vue";
import { useCreateActionMutation } from "./useAction";
import { use_explorer } from "./useExplorer";

const explorer_store = use_explorer();
const { mutateAsync: createAction } = useCreateActionMutation();
const client_detail = use_client_detail();

type ViewState =
  | "loading"
  | "showingFiles"
  | "showingDisks"
  | "showingActionStatus"
  | "notFound";

const view_state: ComputedRef<ViewState> = computed(() => {
  if (explorer_store.loading.get_files) {
    return "loading";
  }
  if (
    explorer_store.files &&
    explorer_store.files.filter((f) => f.name && f.type).length > 0
  ) {
    return "showingFiles";
  }
  if (!explorer_store.init_path && client_detail.client_detail?.disk?.length) {
    return "showingDisks";
  }
  // if (explorer_store.action && explorer_store.action.status !== "complete") {
  //   return "showingActionStatus";
  // }
  return "notFound";
});

onMounted(() => {
  explorer_store.get_extensions();
  explorer_store.get_files();

  document
    .getElementById("confirm_upload")
    ?.addEventListener("close", async (e) => {
      const dialog = e.target as HTMLDialogElement;
      const file_input = document.getElementById(
        "file-upload",
      ) as HTMLInputElement | null;
      if (dialog.returnValue !== "confirm") {
        explorer_store.upload_file = undefined;
        if (file_input) file_input.value = "";
      }
    });
  return () => {
    document
      .getElementById("confirm_upload")
      ?.removeEventListener("close", () => {});
  };
});

const handle_file_upload = (event: Event) => {
  const upload_modal = document.getElementById(
    "confirm_upload",
  ) as HTMLDialogElement | null;
  const target = event.target as HTMLInputElement;
  const files = target.files;
  if (files && files.length > 0) {
    explorer_store.upload_file = files[0];
    if (upload_modal) upload_modal.showModal();
  }
};
</script>
